const customLangs = {
    gb: {
        _name: 'English',
        fullScreenComplianceDocuments: {
            documentsTitle: {
                evilion: ["SEC Compliance & Registration", "ESMA Regulatory Compliance Document"],
                stage: ["Approved Swiss collective investment schemes", "Client Financial Questionnaire", "Alpina Swiss Agreement"],
                alpswissltd: ["Approved Swiss collective investment schemes", "Client Financial Questionnaire", "Alpina Swiss Agreement"],
            },
            documentsDesc: {
                evilion: ["United States Securities and Exchange Commission", "European Securities and Markets Authority"],
                stage: ["FINMA List of Regulated Companies", "Financial Questionnaire", "Assets Management Agreement"],
                alpswissltd: ["FINMA List of Regulated Companies", "Financial Questionnaire", "Assets Management Agreement"],
            }
        },
        newDesign: {
            other: {
                trustisag: "Einkommensnachweis"
            },
            otherDocuments: {
                trustisag: "Letzte Lohnabrechnung oder letzter Rentenbescheid.<br>Falls Sie eine Rente beziehen und zusätzlich arbeiten, laden Sie bitte beide Dokumente hoch.<br>Diese Angaben werden zur Deklaration Ihrer Einkünfte aus dem Handel an der Börse benötigt."
            },
            savingsAccounts: {
                canadatokentrade: 'Savings/IPO/ICO',
                avxsolutions: 'Savings/IPO/ICO',
            },
        },
        fullScreen: {
            savings: {
                canadatokentrade: 'Savings/IPO/ICO',
                avxsolutions: 'Savings/IPO/ICO',
            }
        },
    },
    ru: {
        _name: 'Русский',
        fullScreenComplianceDocuments: {
            documentsTitle: {
                evilion: ["SEC Compliance & Registration", "ESMA Regulatory Compliance Document"],
                stage: ["Approved Swiss collective investment schemes", "Client Financial Questionnaire", "Alpina Swiss Agreement"],
                alpswissltd: ["Approved Swiss collective investment schemes", "Client Financial Questionnaire", "Alpina Swiss Agreement"],
            },
            documentsDesc: {
                evilion: ["United States Securities and Exchange Commission", "European Securities and Markets Authority"],
                stage: ["FINMA List of Regulated Companies", "Financial Questionnaire", "Assets Management Agreement"],
                alpswissltd: ["FINMA List of Regulated Companies", "Financial Questionnaire", "Assets Management Agreement"],
            }
        },
        newDesign: {
            other: {
                trustisag: "Einkommensnachweis"
            },
            otherDocuments: {
                trustisag: "Letzte Lohnabrechnung oder letzter Rentenbescheid.<br>Falls Sie eine Rente beziehen und zusätzlich arbeiten, laden Sie bitte beide Dokumente hoch.<br>Diese Angaben werden zur Deklaration Ihrer Einkünfte aus dem Handel an der Börse benötigt."
            },
            savingsAccounts: {
                canadatokentrade: 'Savings/IPO/ICO',
                avxsolutions: 'Savings/IPO/ICO',
            },
        },
        fullScreen: {
            savings: {
                canadatokentrade: 'Savings/IPO/ICO',
                avxsolutions: 'Savings/IPO/ICO',
            }
        },
    },
    pl: {
        _name: 'Polski',
        fullScreenComplianceDocuments: {
            documentsTitle: {
                evilion: ["SEC Compliance & Registration", "ESMA Regulatory Compliance Document"],
                stage: ["Approved Swiss collective investment schemes", "Client Financial Questionnaire", "Alpina Swiss Agreement"],
                alpswissltd: ["Approved Swiss collective investment schemes", "Client Financial Questionnaire", "Alpina Swiss Agreement"],
            },
            documentsDesc: {
                evilion: ["United States Securities and Exchange Commission", "European Securities and Markets Authority"],
                stage: ["FINMA List of Regulated Companies", "Financial Questionnaire", "Assets Management Agreement"],
                alpswissltd: ["FINMA List of Regulated Companies", "Financial Questionnaire", "Assets Management Agreement"],
            }
        },
        newDesign: {
            other: {
                trustisag: "Einkommensnachweis"
            },
            otherDocuments: {
                trustisag: "Letzte Lohnabrechnung oder letzter Rentenbescheid.<br>Falls Sie eine Rente beziehen und zusätzlich arbeiten, laden Sie bitte beide Dokumente hoch.<br>Diese Angaben werden zur Deklaration Ihrer Einkünfte aus dem Handel an der Börse benötigt."
            },
            savingsAccounts: {
                canadatokentrade: 'Savings/IPO/ICO',
                avxsolutions: 'Savings/IPO/ICO',
            },
        },
        fullScreen: {
            savings: {
                canadatokentrade: 'Savings/IPO/ICO',
                avxsolutions: 'Savings/IPO/ICO',
            }
        },
    },
    cz: {
        _name: 'Čeština',
        fullScreenComplianceDocuments: {
            documentsTitle: {
                evilion: ["SEC Compliance & Registration", "ESMA Regulatory Compliance Document"],
                stage: ["Approved Swiss collective investment schemes", "Client Financial Questionnaire", "Alpina Swiss Agreement"],
                alpswissltd: ["Approved Swiss collective investment schemes", "Client Financial Questionnaire", "Alpina Swiss Agreement"],
            },
            documentsDesc: {
                evilion: ["United States Securities and Exchange Commission", "European Securities and Markets Authority"],
                stage: ["FINMA List of Regulated Companies", "Financial Questionnaire", "Assets Management Agreement"],
                alpswissltd: ["FINMA List of Regulated Companies", "Financial Questionnaire", "Assets Management Agreement"],
            }
        },
        newDesign: {
            other: {
                trustisag: "Einkommensnachweis"
            },
            otherDocuments: {
                trustisag: "Letzte Lohnabrechnung oder letzter Rentenbescheid.<br>Falls Sie eine Rente beziehen und zusätzlich arbeiten, laden Sie bitte beide Dokumente hoch.<br>Diese Angaben werden zur Deklaration Ihrer Einkünfte aus dem Handel an der Börse benötigt."
            },
            savingsAccounts: {
                canadatokentrade: 'Savings/IPO/ICO',
                avxsolutions: 'Savings/IPO/ICO',
            },
        },
        fullScreen: {
            savings: {
                canadatokentrade: 'Savings/IPO/ICO',
                avxsolutions: 'Savings/IPO/ICO',
            }
        },
    },
    de: {
        _name: 'Deutsch',
        fullScreenComplianceDocuments: {
            documentsTitle: {
                evilion: ["SEC Compliance & Registration", "ESMA Regulatory Compliance Document"],
                stage: ["Approved Swiss collective investment schemes", "Client Financial Questionnaire", "Alpina Swiss Agreement"],
                alpswissltd: ["Approved Swiss collective investment schemes", "Client Financial Questionnaire", "Alpina Swiss Agreement"],
            },
            documentsDesc: {
                evilion: ["United States Securities and Exchange Commission", "European Securities and Markets Authority"],
                stage: ["FINMA List of Regulated Companies", "Financial Questionnaire", "Assets Management Agreement"],
                alpswissltd: ["FINMA List of Regulated Companies", "Financial Questionnaire", "Assets Management Agreement"],
            }
        },
        newDesign: {
            other: {
                trustisag: "Einkommensnachweis"
            },
            otherDocuments: {
                trustisag: "Letzte Lohnabrechnung oder letzter Rentenbescheid.<br>Falls Sie eine Rente beziehen und zusätzlich arbeiten, laden Sie bitte beide Dokumente hoch.<br>Diese Angaben werden zur Deklaration Ihrer Einkünfte aus dem Handel an der Börse benötigt."
            },
            savingsAccounts: {
                canadatokentrade: 'Savings/IPO/ICO',
                avxsolutions: 'Savings/IPO/ICO',
            },
        },
        fullScreen: {
            savings: {
                canadatokentrade: 'Savings/IPO/ICO',
                avxsolutions: 'Savings/IPO/ICO',
            }
        },
    },
    fr: {
        _name: 'Français',
        fullScreenComplianceDocuments: {
            documentsTitle: {
                evilion: ["SEC Compliance & Registration", "ESMA Regulatory Compliance Document"],
                stage: ["Approved Swiss collective investment schemes", "Client Financial Questionnaire", "Alpina Swiss Agreement"],
                alpswissltd: ["Approved Swiss collective investment schemes", "Client Financial Questionnaire", "Alpina Swiss Agreement"],
            },
            documentsDesc: {
                evilion: ["United States Securities and Exchange Commission", "European Securities and Markets Authority"],
                stage: ["FINMA List of Regulated Companies", "Financial Questionnaire", "Assets Management Agreement"],
                alpswissltd: ["FINMA List of Regulated Companies", "Financial Questionnaire", "Assets Management Agreement"],
            }
        },
        newDesign: {
            other: {
                trustisag: "Einkommensnachweis"
            },
            otherDocuments: {
                trustisag: "Letzte Lohnabrechnung oder letzter Rentenbescheid.<br>Falls Sie eine Rente beziehen und zusätzlich arbeiten, laden Sie bitte beide Dokumente hoch.<br>Diese Angaben werden zur Deklaration Ihrer Einkünfte aus dem Handel an der Börse benötigt."
            },
            savingsAccounts: {
                canadatokentrade: 'Savings/IPO/ICO',
                avxsolutions: 'Savings/IPO/ICO',
            },
        },
        fullScreen: {
            savings: {
                canadatokentrade: 'Savings/IPO/ICO',
                avxsolutions: 'Savings/IPO/ICO',
            }
        }
    },
    es: {
        _name: 'Español',
        fullScreenComplianceDocuments: {
            documentsTitle: {
                evilion: ["SEC Compliance & Registration", "ESMA Regulatory Compliance Document"],
                stage: ["Approved Swiss collective investment schemes", "Client Financial Questionnaire", "Alpina Swiss Agreement"],
                alpswissltd: ["Approved Swiss collective investment schemes", "Client Financial Questionnaire", "Alpina Swiss Agreement"],
            },
            documentsDesc: {
                evilion: ["United States Securities and Exchange Commission", "European Securities and Markets Authority"],
                stage: ["FINMA List of Regulated Companies", "Financial Questionnaire", "Assets Management Agreement"],
                alpswissltd: ["FINMA List of Regulated Companies", "Financial Questionnaire", "Assets Management Agreement"],
            }
        },
        newDesign: {
            other: {
                trustisag: "Einkommensnachweis"
            },
            otherDocuments: {
                trustisag: "Letzte Lohnabrechnung oder letzter Rentenbescheid.<br>Falls Sie eine Rente beziehen und zusätzlich arbeiten, laden Sie bitte beide Dokumente hoch.<br>Diese Angaben werden zur Deklaration Ihrer Einkünfte aus dem Handel an der Börse benötigt."
            },
            savingsAccounts: {
                canadatokentrade: 'Savings/IPO/ICO',
                avxsolutions: 'Savings/IPO/ICO',
            },
        },
        fullScreen: {
            savings: {
                canadatokentrade: 'Savings/IPO/ICO',
                avxsolutions: 'Savings/IPO/ICO',
            }
        },
    },
    dk: {
        _name: 'Dansk',
        fullScreenComplianceDocuments: {
            documentsTitle: {
                evilion: ["SEC Compliance & Registration", "ESMA Regulatory Compliance Document"],
                stage: ["Approved Swiss collective investment schemes", "Client Financial Questionnaire", "Alpina Swiss Agreement"],
                alpswissltd: ["Approved Swiss collective investment schemes", "Client Financial Questionnaire", "Alpina Swiss Agreement"],
            },
            documentsDesc: {
                evilion: ["United States Securities and Exchange Commission", "European Securities and Markets Authority"],
                stage: ["FINMA List of Regulated Companies", "Financial Questionnaire", "Assets Management Agreement"],
                alpswissltd: ["FINMA List of Regulated Companies", "Financial Questionnaire", "Assets Management Agreement"],
            }
        },
        newDesign: {
            other: {
                trustisag: "Einkommensnachweis"
            },
            otherDocuments: {
                trustisag: "Letzte Lohnabrechnung oder letzter Rentenbescheid.<br>Falls Sie eine Rente beziehen und zusätzlich arbeiten, laden Sie bitte beide Dokumente hoch.<br>Diese Angaben werden zur Deklaration Ihrer Einkünfte aus dem Handel an der Börse benötigt."
            },
            savingsAccounts: {
                canadatokentrade: 'Savings/IPO/ICO',
                avxsolutions: 'Savings/IPO/ICO',
            },
        },
        fullScreen: {
            savings: {
                canadatokentrade: 'Savings/IPO/ICO',
                avxsolutions: 'Savings/IPO/ICO',
            }
        },
    },
    nl: {
        _name: 'Nederlandse taal',
        fullScreenComplianceDocuments: {
            documentsTitle: {
                evilion: ["SEC Compliance & Registration", "ESMA Regulatory Compliance Document"],
                stage: ["Approved Swiss collective investment schemes", "Client Financial Questionnaire", "Alpina Swiss Agreement"],
                alpswissltd: ["Approved Swiss collective investment schemes", "Client Financial Questionnaire", "Alpina Swiss Agreement"],
            },
            documentsDesc: {
                evilion: ["United States Securities and Exchange Commission", "European Securities and Markets Authority"],
                stage: ["FINMA List of Regulated Companies", "Financial Questionnaire", "Assets Management Agreement"],
                alpswissltd: ["FINMA List of Regulated Companies", "Financial Questionnaire", "Assets Management Agreement"],
            }
        },
        newDesign: {
            other: {
                trustisag: "Einkommensnachweis"
            },
            otherDocuments: {
                trustisag: "Letzte Lohnabrechnung oder letzter Rentenbescheid.<br>Falls Sie eine Rente beziehen und zusätzlich arbeiten, laden Sie bitte beide Dokumente hoch.<br>Diese Angaben werden zur Deklaration Ihrer Einkünfte aus dem Handel an der Börse benötigt."
            },
            savingsAccounts: {
                canadatokentrade: 'Savings/IPO/ICO',
                avxsolutions: 'Savings/IPO/ICO',
            },
        },
        fullScreen: {
            savings: {
                canadatokentrade: 'Savings/IPO/ICO',
                avxsolutions: 'Savings/IPO/ICO',
            }
        },
    },
    sa: {
        _name: 'عربي',
        fullScreenComplianceDocuments: {
            documentsTitle: {
                evilion: ["SEC Compliance & Registration", "ESMA Regulatory Compliance Document"],
                stage: ["Approved Swiss collective investment schemes", "Client Financial Questionnaire", "Alpina Swiss Agreement"],
                alpswissltd: ["Approved Swiss collective investment schemes", "Client Financial Questionnaire", "Alpina Swiss Agreement"],
            },
            documentsDesc: {
                evilion: ["United States Securities and Exchange Commission", "European Securities and Markets Authority"],
                stage: ["FINMA List of Regulated Companies", "Financial Questionnaire", "Assets Management Agreement"],
                alpswissltd: ["FINMA List of Regulated Companies", "Financial Questionnaire", "Assets Management Agreement"],
            }
        },
        newDesign: {
            other: {
                trustisag: "Einkommensnachweis"
            },
            otherDocuments: {
                trustisag: "Letzte Lohnabrechnung oder letzter Rentenbescheid.<br>Falls Sie eine Rente beziehen und zusätzlich arbeiten, laden Sie bitte beide Dokumente hoch.<br>Diese Angaben werden zur Deklaration Ihrer Einkünfte aus dem Handel an der Börse benötigt."
            },
            savingsAccounts: {
                canadatokentrade: 'Savings/IPO/ICO',
                avxsolutions: 'Savings/IPO/ICO',
            },
        },
        fullScreen: {
            savings: {
                canadatokentrade: 'Savings/IPO/ICO',
                avxsolutions: 'Savings/IPO/ICO',
            }
        },
    },
    it: {
        _name: 'Italiano',
        fullScreenComplianceDocuments: {
            documentsTitle: {
                evilion: ["SEC Compliance & Registration", "ESMA Regulatory Compliance Document"],
                stage: ["Approved Swiss collective investment schemes", "Client Financial Questionnaire", "Alpina Swiss Agreement"],
                alpswissltd: ["Approved Swiss collective investment schemes", "Client Financial Questionnaire", "Alpina Swiss Agreement"],
            },
            documentsDesc: {
                evilion: ["United States Securities and Exchange Commission", "European Securities and Markets Authority"],
                stage: ["FINMA List of Regulated Companies", "Financial Questionnaire", "Assets Management Agreement"],
                alpswissltd: ["FINMA List of Regulated Companies", "Financial Questionnaire", "Assets Management Agreement"],
            }
        },
        newDesign: {
            other: {
                trustisag: "Einkommensnachweis"
            },
            otherDocuments: {
                trustisag: "Letzte Lohnabrechnung oder letzter Rentenbescheid.<br>Falls Sie eine Rente beziehen und zusätzlich arbeiten, laden Sie bitte beide Dokumente hoch.<br>Diese Angaben werden zur Deklaration Ihrer Einkünfte aus dem Handel an der Börse benötigt."
            },
            savingsAccounts: {
                canadatokentrade: 'Savings/IPO/ICO',
                avxsolutions: 'Savings/IPO/ICO',
            },
        },
        fullScreen: {
            savings: {
                canadatokentrade: 'Savings/IPO/ICO',
                avxsolutions: 'Savings/IPO/ICO',
            }
        },
    },
    sk: {
        _name: 'Slovak',
        fullScreenComplianceDocuments: {
            documentsTitle: {
                evilion: ["SEC Compliance & Registration", "ESMA Regulatory Compliance Document"],
                stage: ["Approved Swiss collective investment schemes", "Client Financial Questionnaire", "Alpina Swiss Agreement"],
                alpswissltd: ["Approved Swiss collective investment schemes", "Client Financial Questionnaire", "Alpina Swiss Agreement"],
            },
            documentsDesc: {
                evilion: ["United States Securities and Exchange Commission", "European Securities and Markets Authority"],
                stage: ["FINMA List of Regulated Companies", "Financial Questionnaire", "Assets Management Agreement"],
                alpswissltd: ["FINMA List of Regulated Companies", "Financial Questionnaire", "Assets Management Agreement"],
            }
        },
        newDesign: {
            other: {
                trustisag: "Einkommensnachweis"
            },
            otherDocuments: {
                trustisag: "Letzte Lohnabrechnung oder letzter Rentenbescheid.<br>Falls Sie eine Rente beziehen und zusätzlich arbeiten, laden Sie bitte beide Dokumente hoch.<br>Diese Angaben werden zur Deklaration Ihrer Einkünfte aus dem Handel an der Börse benötigt."
            },
            savingsAccounts: {
                canadatokentrade: 'Savings/IPO/ICO',
                avxsolutions: 'Savings/IPO/ICO',
            },
        },
        fullScreen: {
            savings: {
                canadatokentrade: 'Savings/IPO/ICO',
                avxsolutions: 'Savings/IPO/ICO',
            }
        },
    },
    hu: {
        _name: 'Hungarian',
        fullScreenComplianceDocuments: {
            documentsTitle: {
                evilion: ["SEC Compliance & Registration", "ESMA Regulatory Compliance Document"],
                stage: ["Approved Swiss collective investment schemes", "Client Financial Questionnaire", "Alpina Swiss Agreement"],
                alpswissltd: ["Approved Swiss collective investment schemes", "Client Financial Questionnaire", "Alpina Swiss Agreement"],
            },
            documentsDesc: {
                evilion: ["United States Securities and Exchange Commission", "European Securities and Markets Authority"],
                stage: ["FINMA List of Regulated Companies", "Financial Questionnaire", "Assets Management Agreement"],
                alpswissltd: ["FINMA List of Regulated Companies", "Financial Questionnaire", "Assets Management Agreement"],
            }
        },
        newDesign: {
            other: {
                trustisag: "Einkommensnachweis"
            },
            otherDocuments: {
                trustisag: "Letzte Lohnabrechnung oder letzter Rentenbescheid.<br>Falls Sie eine Rente beziehen und zusätzlich arbeiten, laden Sie bitte beide Dokumente hoch.<br>Diese Angaben werden zur Deklaration Ihrer Einkünfte aus dem Handel an der Börse benötigt."
            },
            savingsAccounts: {
                canadatokentrade: 'Savings/IPO/ICO',
                avxsolutions: 'Savings/IPO/ICO',
            },
        },
        fullScreen: {
            savings: {
                canadatokentrade: 'Savings/IPO/ICO',
                avxsolutions: 'Savings/IPO/ICO',
            }
        },
    },
    ro: {
        _name: 'Romanian',
        fullScreenComplianceDocuments: {
            documentsTitle: {
                evilion: ["SEC Compliance & Registration", "ESMA Regulatory Compliance Document"],
                stage: ["Approved Swiss collective investment schemes", "Client Financial Questionnaire", "Alpina Swiss Agreement"],
                alpswissltd: ["Approved Swiss collective investment schemes", "Client Financial Questionnaire", "Alpina Swiss Agreement"],
            },
            documentsDesc: {
                evilion: ["United States Securities and Exchange Commission", "European Securities and Markets Authority"],
                stage: ["FINMA List of Regulated Companies", "Financial Questionnaire", "Assets Management Agreement"],
                alpswissltd: ["FINMA List of Regulated Companies", "Financial Questionnaire", "Assets Management Agreement"],
            }
        },
        newDesign: {
            other: {
                trustisag: "Einkommensnachweis"
            },
            otherDocuments: {
                trustisag: "Letzte Lohnabrechnung oder letzter Rentenbescheid.<br>Falls Sie eine Rente beziehen und zusätzlich arbeiten, laden Sie bitte beide Dokumente hoch.<br>Diese Angaben werden zur Deklaration Ihrer Einkünfte aus dem Handel an der Börse benötigt."
            },
            savingsAccounts: {
                canadatokentrade: 'Savings/IPO/ICO',
                avxsolutions: 'Savings/IPO/ICO',
            },
        },
        fullScreen: {
            savings: {
                canadatokentrade: 'Savings/IPO/ICO',
                avxsolutions: 'Savings/IPO/ICO',
            }
        },
    },
    ge: {
        _name: 'Georgia',
        fullScreenComplianceDocuments: {
            documentsTitle: {
                evilion: ["SEC Compliance & Registration", "ESMA Regulatory Compliance Document"],
                stage: ["Approved Swiss collective investment schemes", "Client Financial Questionnaire", "Alpina Swiss Agreement"],
                alpswissltd: ["Approved Swiss collective investment schemes", "Client Financial Questionnaire", "Alpina Swiss Agreement"],
            },
            documentsDesc: {
                evilion: ["United States Securities and Exchange Commission", "European Securities and Markets Authority"],
                stage: ["FINMA List of Regulated Companies", "Financial Questionnaire", "Assets Management Agreement"],
                alpswissltd: ["FINMA List of Regulated Companies", "Financial Questionnaire", "Assets Management Agreement"],
            }
        },
        newDesign: {
            other: {
                trustisag: "Einkommensnachweis"
            },
            otherDocuments: {
                trustisag: "Letzte Lohnabrechnung oder letzter Rentenbescheid.<br>Falls Sie eine Rente beziehen und zusätzlich arbeiten, laden Sie bitte beide Dokumente hoch.<br>Diese Angaben werden zur Deklaration Ihrer Einkünfte aus dem Handel an der Börse benötigt."
            },
            savingsAccounts: {
                canadatokentrade: 'Savings/IPO/ICO',
                avxsolutions: 'Savings/IPO/ICO',
            },
        },
        fullScreen: {
            savings: {
                canadatokentrade: 'Savings/IPO/ICO',
                avxsolutions: 'Savings/IPO/ICO',
            }
        },
    },
    az: {
        _name: 'Azerbaijani',
        fullScreenComplianceDocuments: {
            documentsTitle: {
                evilion: ["SEC Compliance & Registration", "ESMA Regulatory Compliance Document"],
                stage: ["Approved Swiss collective investment schemes", "Client Financial Questionnaire", "Alpina Swiss Agreement"],
                alpswissltd: ["Approved Swiss collective investment schemes", "Client Financial Questionnaire", "Alpina Swiss Agreement"],
            },
            documentsDesc: {
                evilion: ["United States Securities and Exchange Commission", "European Securities and Markets Authority"],
                stage: ["FINMA List of Regulated Companies", "Financial Questionnaire", "Assets Management Agreement"],
                alpswissltd: ["FINMA List of Regulated Companies", "Financial Questionnaire", "Assets Management Agreement"],
            }
        },
        newDesign: {
            other: {
                trustisag: "Einkommensnachweis"
            },
            otherDocuments: {
                trustisag: "Letzte Lohnabrechnung oder letzter Rentenbescheid.<br>Falls Sie eine Rente beziehen und zusätzlich arbeiten, laden Sie bitte beide Dokumente hoch.<br>Diese Angaben werden zur Deklaration Ihrer Einkünfte aus dem Handel an der Börse benötigt."
            },
            savingsAccounts: {
                canadatokentrade: 'Savings/IPO/ICO',
                avxsolutions: 'Savings/IPO/ICO',
            },
        },
        fullScreen: {
            savings: {
                canadatokentrade: 'Savings/IPO/ICO',
                avxsolutions: 'Savings/IPO/ICO',
            }
        },
    },
    tr: {
        _name: 'Türkçe',
        fullScreenComplianceDocuments: {
            documentsTitle: {
                evilion: ["SEC Compliance & Registration", "ESMA Regulatory Compliance Document"],
                stage: ["Approved Swiss collective investment schemes", "Client Financial Questionnaire", "Alpina Swiss Agreement"],
                alpswissltd: ["Approved Swiss collective investment schemes", "Client Financial Questionnaire", "Alpina Swiss Agreement"],
            },
            documentsDesc: {
                evilion: ["United States Securities and Exchange Commission", "European Securities and Markets Authority"],
                stage: ["FINMA List of Regulated Companies", "Financial Questionnaire", "Assets Management Agreement"],
                alpswissltd: ["FINMA List of Regulated Companies", "Financial Questionnaire", "Assets Management Agreement"],
            }
        },
        newDesign: {
            other: {
                trustisag: "Einkommensnachweis"
            },
            otherDocuments: {
                trustisag: "Letzte Lohnabrechnung oder letzter Rentenbescheid.<br>Falls Sie eine Rente beziehen und zusätzlich arbeiten, laden Sie bitte beide Dokumente hoch.<br>Diese Angaben werden zur Deklaration Ihrer Einkünfte aus dem Handel an der Börse benötigt."
            },
            savingsAccounts: {
                canadatokentrade: 'Savings/IPO/ICO',
                avxsolutions: 'Savings/IPO/ICO',
            },
        },
        fullScreen: {
            savings: {
                canadatokentrade: 'Savings/IPO/ICO',
                avxsolutions: 'Savings/IPO/ICO',
            }
        },
    },
    rs: {
        _name: 'Srpski',
        fullScreenComplianceDocuments: {
            documentsTitle: {
                evilion: ["SEC Compliance & Registration", "ESMA Regulatory Compliance Document"],
                stage: ["Approved Swiss collective investment schemes", "Client Financial Questionnaire", "Alpina Swiss Agreement"],
                alpswissltd: ["Approved Swiss collective investment schemes", "Client Financial Questionnaire", "Alpina Swiss Agreement"],
            },
            documentsDesc: {
                evilion: ["United States Securities and Exchange Commission", "European Securities and Markets Authority"],
                stage: ["FINMA List of Regulated Companies", "Financial Questionnaire", "Assets Management Agreement"],
                alpswissltd: ["FINMA List of Regulated Companies", "Financial Questionnaire", "Assets Management Agreement"],
            }
        },
        newDesign: {
            other: {
                trustisag: "Einkommensnachweis"
            },
            otherDocuments: {
                trustisag: "Letzte Lohnabrechnung oder letzter Rentenbescheid.<br>Falls Sie eine Rente beziehen und zusätzlich arbeiten, laden Sie bitte beide Dokumente hoch.<br>Diese Angaben werden zur Deklaration Ihrer Einkünfte aus dem Handel an der Börse benötigt."
            },
            savingsAccounts: {
                canadatokentrade: 'Savings/IPO/ICO',
                avxsolutions: 'Savings/IPO/ICO',
            },
        },
        fullScreen: {
            savings: {
                canadatokentrade: 'Savings/IPO/ICO',
                avxsolutions: 'Savings/IPO/ICO',
            }
        },
    },
    pt: {
        _name: 'Português',
        fullScreenComplianceDocuments: {
            documentsTitle: {
                evilion: ["SEC Compliance & Registration", "ESMA Regulatory Compliance Document"],
                stage: ["Approved Swiss collective investment schemes", "Client Financial Questionnaire", "Alpina Swiss Agreement"],
                alpswissltd: ["Approved Swiss collective investment schemes", "Client Financial Questionnaire", "Alpina Swiss Agreement"],
            },
            documentsDesc: {
                evilion: ["United States Securities and Exchange Commission", "European Securities and Markets Authority"],
                stage: ["FINMA List of Regulated Companies", "Financial Questionnaire", "Assets Management Agreement"],
                alpswissltd: ["FINMA List of Regulated Companies", "Financial Questionnaire", "Assets Management Agreement"],
            }
        },
        newDesign: {
            other: {
                trustisag: "Einkommensnachweis"
            },
            otherDocuments: {
                trustisag: "Letzte Lohnabrechnung oder letzter Rentenbescheid.<br>Falls Sie eine Rente beziehen und zusätzlich arbeiten, laden Sie bitte beide Dokumente hoch.<br>Diese Angaben werden zur Deklaration Ihrer Einkünfte aus dem Handel an der Börse benötigt."
            },
            savingsAccounts: {
                canadatokentrade: 'Savings/IPO/ICO',
                avxsolutions: 'Savings/IPO/ICO',
            },
        },
        fullScreen: {
            savings: {
                canadatokentrade: 'Savings/IPO/ICO',
                avxsolutions: 'Savings/IPO/ICO',
            }
        },
    },
    jp: {
        _name: '日本語',
        fullScreenComplianceDocuments: {
            documentsTitle: {
                evilion: ["SEC Compliance & Registration", "ESMA Regulatory Compliance Document"],
                stage: ["Approved Swiss collective investment schemes", "Client Financial Questionnaire", "Alpina Swiss Agreement"],
                alpswissltd: ["Approved Swiss collective investment schemes", "Client Financial Questionnaire", "Alpina Swiss Agreement"],
            },
            documentsDesc: {
                evilion: ["United States Securities and Exchange Commission", "European Securities and Markets Authority"],
                stage: ["FINMA List of Regulated Companies", "Financial Questionnaire", "Assets Management Agreement"],
                alpswissltd: ["FINMA List of Regulated Companies", "Financial Questionnaire", "Assets Management Agreement"],
            }
        },
        newDesign: {
            other: {
                trustisag: "Einkommensnachweis"
            },
            otherDocuments: {
                trustisag: "Letzte Lohnabrechnung oder letzter Rentenbescheid.<br>Falls Sie eine Rente beziehen und zusätzlich arbeiten, laden Sie bitte beide Dokumente hoch.<br>Diese Angaben werden zur Deklaration Ihrer Einkünfte aus dem Handel an der Börse benötigt."
            },
            savingsAccounts: {
                canadatokentrade: 'Savings/IPO/ICO',
                avxsolutions: 'Savings/IPO/ICO',
            },
        },
        fullScreen: {
            savings: {
                canadatokentrade: 'Savings/IPO/ICO',
                avxsolutions: 'Savings/IPO/ICO',
            }
        },
    },
    hr: {
        _name: 'Hrvatski',
        fullScreenComplianceDocuments: {
            documentsTitle: {
                evilion: ["SEC Compliance & Registration", "ESMA Regulatory Compliance Document"],
                stage: ["Approved Swiss collective investment schemes", "Client Financial Questionnaire", "Alpina Swiss Agreement"],
                alpswissltd: ["Approved Swiss collective investment schemes", "Client Financial Questionnaire", "Alpina Swiss Agreement"],
            },
            documentsDesc: {
                evilion: ["United States Securities and Exchange Commission", "European Securities and Markets Authority"],
                stage: ["FINMA List of Regulated Companies", "Financial Questionnaire", "Assets Management Agreement"],
                alpswissltd: ["FINMA List of Regulated Companies", "Financial Questionnaire", "Assets Management Agreement"],
            }
        },
        newDesign: {
            other: {
                trustisag: "Einkommensnachweis"
            },
            otherDocuments: {
                trustisag: "Letzte Lohnabrechnung oder letzter Rentenbescheid.<br>Falls Sie eine Rente beziehen und zusätzlich arbeiten, laden Sie bitte beide Dokumente hoch.<br>Diese Angaben werden zur Deklaration Ihrer Einkünfte aus dem Handel an der Börse benötigt."
            },
            savingsAccounts: {
                canadatokentrade: 'Savings/IPO/ICO',
                avxsolutions: 'Savings/IPO/ICO',
            },
        },
        fullScreen: {
            savings: {
                canadatokentrade: 'Savings/IPO/ICO',
                avxsolutions: 'Savings/IPO/ICO',
            }
        },
    },
    kz: {
        _name: 'Қазақ тілі',
        fullScreenComplianceDocuments: {
            documentsTitle: {
                evilion: ["SEC Compliance & Registration", "ESMA Regulatory Compliance Document"],
                stage: ["Approved Swiss collective investment schemes", "Client Financial Questionnaire", "Alpina Swiss Agreement"],
                alpswissltd: ["Approved Swiss collective investment schemes", "Client Financial Questionnaire", "Alpina Swiss Agreement"],
            },
            documentsDesc: {
                evilion: ["United States Securities and Exchange Commission", "European Securities and Markets Authority"],
                stage: ["FINMA List of Regulated Companies", "Financial Questionnaire", "Assets Management Agreement"],
                alpswissltd: ["FINMA List of Regulated Companies", "Financial Questionnaire", "Assets Management Agreement"],
            }
        },
        newDesign: {
            other: {
                trustisag: "Einkommensnachweis"
            },
            otherDocuments: {
                trustisag: "Letzte Lohnabrechnung oder letzter Rentenbescheid.<br>Falls Sie eine Rente beziehen und zusätzlich arbeiten, laden Sie bitte beide Dokumente hoch.<br>Diese Angaben werden zur Deklaration Ihrer Einkünfte aus dem Handel an der Börse benötigt."
            },
            savingsAccounts: {
                canadatokentrade: 'Savings/IPO/ICO',
                avxsolutions: 'Savings/IPO/ICO',
            },
        },
        fullScreen: {
            savings: {
                canadatokentrade: 'Savings/IPO/ICO',
                avxsolutions: 'Savings/IPO/ICO',
            }
        },
    },
    kg: {
        _name: 'Кыргыз тили',
        fullScreenComplianceDocuments: {
            documentsTitle: {
                evilion: ["SEC Compliance & Registration", "ESMA Regulatory Compliance Document"],
                stage: ["Approved Swiss collective investment schemes", "Client Financial Questionnaire", "Alpina Swiss Agreement"],
                alpswissltd: ["Approved Swiss collective investment schemes", "Client Financial Questionnaire", "Alpina Swiss Agreement"],
            },
            documentsDesc: {
                evilion: ["United States Securities and Exchange Commission", "European Securities and Markets Authority"],
                stage: ["FINMA List of Regulated Companies", "Financial Questionnaire", "Assets Management Agreement"],
                alpswissltd: ["FINMA List of Regulated Companies", "Financial Questionnaire", "Assets Management Agreement"],
            }
        },
        newDesign: {
            other: {
                trustisag: "Einkommensnachweis"
            },
            otherDocuments: {
                trustisag: "Letzte Lohnabrechnung oder letzter Rentenbescheid.<br>Falls Sie eine Rente beziehen und zusätzlich arbeiten, laden Sie bitte beide Dokumente hoch.<br>Diese Angaben werden zur Deklaration Ihrer Einkünfte aus dem Handel an der Börse benötigt."
            },
            savingsAccounts: {
                canadatokentrade: 'Savings/IPO/ICO',
                avxsolutions: 'Savings/IPO/ICO',
            },
        },
        fullScreen: {
            savings: {
                canadatokentrade: 'Savings/IPO/ICO',
                avxsolutions: 'Savings/IPO/ICO',
            }
        },
    },
    cn: {
        _name: '中文',
        fullScreenComplianceDocuments: {
            documentsTitle: {
                evilion: ["SEC Compliance & Registration", "ESMA Regulatory Compliance Document"],
                stage: ["Approved Swiss collective investment schemes", "Client Financial Questionnaire", "Alpina Swiss Agreement"],
                alpswissltd: ["Approved Swiss collective investment schemes", "Client Financial Questionnaire", "Alpina Swiss Agreement"],
            },
            documentsDesc: {
                evilion: ["United States Securities and Exchange Commission", "European Securities and Markets Authority"],
                stage: ["FINMA List of Regulated Companies", "Financial Questionnaire", "Assets Management Agreement"],
                alpswissltd: ["FINMA List of Regulated Companies", "Financial Questionnaire", "Assets Management Agreement"],
            }
        },
        newDesign: {
            other: {
                trustisag: "Einkommensnachweis"
            },
            otherDocuments: {
                trustisag: "Letzte Lohnabrechnung oder letzter Rentenbescheid.<br>Falls Sie eine Rente beziehen und zusätzlich arbeiten, laden Sie bitte beide Dokumente hoch.<br>Diese Angaben werden zur Deklaration Ihrer Einkünfte aus dem Handel an der Börse benötigt."
            },
            savingsAccounts: {
                canadatokentrade: 'Savings/IPO/ICO',
                avxsolutions: 'Savings/IPO/ICO',
            },
        },
        fullScreen: {
            savings: {
                canadatokentrade: 'Savings/IPO/ICO',
                avxsolutions: 'Savings/IPO/ICO',
            }
        },
    }
}

export default customLangs
